import { render } from "./FooterSectionXxl.vue?vue&type=template&id=254bf8cf&scoped=true"
import script from "./FooterSectionXxl.vue?vue&type=script&lang=js"
export * from "./FooterSectionXxl.vue?vue&type=script&lang=js"

import "./FooterSectionXxl.vue?vue&type=style&index=0&id=254bf8cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254bf8cf"]])

export default __exports__